import { CableDirection, CableUnit } from '../models/CableUnits';

// Answers to a CableUnits question are stored as JSON in the answer's text value.
// The version lets us change the row shape later and still read old answers.
const CURRENT_VERSION = 1;

interface StoredCableUnits {
  v: number;
  rows: CableUnit[];
}

export const createEmptyCableUnit = (): CableUnit => ({
  leftEarth: false,
  leftUnit: '',
  direction: CableDirection.Both,
  rightUnit: '',
  rightEarth: false
});

export const isBlankCableUnit = (unit: CableUnit) =>
  !unit.leftEarth && !unit.rightEarth && !unit.leftUnit.trim() && !unit.rightUnit.trim();

const toCableDirection = (value: unknown): CableDirection =>
  Object.values(CableDirection).includes(value as CableDirection) ? (value as CableDirection) : CableDirection.Both;

const toCableUnit = (row: any): CableUnit => ({
  leftEarth: row?.leftEarth === true,
  leftUnit: typeof row?.leftUnit === 'string' ? row.leftUnit : '',
  direction: toCableDirection(row?.direction),
  rightUnit: typeof row?.rightUnit === 'string' ? row.rightUnit : '',
  rightEarth: row?.rightEarth === true
});

export const parseCableUnits = (value?: string): CableUnit[] => {
  if (!value) return [];

  try {
    const stored = JSON.parse(value) as StoredCableUnits;
    return Array.isArray(stored?.rows) ? stored.rows.map(toCableUnit) : [];
  } catch {
    return [];
  }
};

// Blank rows are dropped, and an empty table is saved as no answer so mandatory validation still applies.
export const serializeCableUnits = (units: CableUnit[]): string | undefined => {
  const rows = units.filter((unit) => !isBlankCableUnit(unit));
  if (rows.length === 0) return undefined;

  const stored: StoredCableUnits = { v: CURRENT_VERSION, rows };
  return JSON.stringify(stored);
};

export const getCableDirectionArrow = (direction: CableDirection) => {
  switch (direction) {
    case CableDirection.Left:
      return '←';
    case CableDirection.Right:
      return '→';
    default:
      return '↔';
  }
};
